import { ClickNavigationProps } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { RightCapitalContactSyncSettings } from './RightCapitalContactSyncSettings'

export const RightCapitalSpecificSettings = (): ClickNavigationProps[] => {
  return [{ id: 'contactSync', label: 'Contact Sync', content: () => <RightCapitalContactSyncSettings /> }]
}
